import { GameApplicationType } from '../../enums/game-scene';

export const getScreenResolution = (mode) => {
  mode = GameApplicationType.mobile;
  const { innerWidth, innerHeight } = window;
  let width = innerWidth;
  let height;
  switch (mode) {
    case GameApplicationType.mobile:
      height = (width * 16) / 9;

      return {
        canvasContainer: {
          height,
          width,
          transform: `scale(${innerHeight / height > 1.1 ? 1.1 : 1})`,
          top: `${innerHeight / height > 1.1 ? 0 : -80}px`,
        },
      };

    case GameApplicationType.web:
    default:
      height = (width * 9) / 16;
      if (height > innerHeight) {
        height = innerHeight;
        width = (height * 16) / 9;
      }
      return {
        height,
        width,
      };
  }
};
